import React from 'react';
import { Toolbar, Grid, Stack, MenuItem, Button, IconButton, Paper, InputAdornment } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import SaveAltIcon from '@mui/icons-material/SaveAlt'; 
import { Link } from "react-router-dom"
import { useFormik } from 'formik';
import get from "lodash/get";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "react-json-to-excel";

import InputText from "../../../components/form/InputText";
import { current } from '@reduxjs/toolkit';

const ToolbarComponent = ({ setFilter, __, reload, isLoading }) => {
const clients = useSelector(state => state.masters.client);

    const onSubmit = (values) => {
        let Filters = {
            customerID: get(values, "customerId"),
            name: get(values, "name"),
            isActive: get(values, "isActive")
            }

        // if (!!values.name) { Filters = `customerId=${values.customerId}` + `&name=${values.name}`}
        // // switch (get(values, "isActive")) {
        // //     case 1: { Filters = `${!!Filters ? `${Filters},` : ""}&isActive=true` }; break;
        // //     case 2: { Filters = `${!!Filters ? `${Filters},` : ""}&isActive=false` }; break;
        // //     default: break;
        // // }    
        setFilter(Filters)
    }

    const isActive = [
        {
            value: 0,
            name: __(`isActive.all`),
        },
        {
            value: 1,
            name: __(`isActive.true`),
        },
        {
            value: 2,
            name: __(`isActive.false`),
        },
    ]

    const formik = useFormik({
        initialValues: {
            name: "",
            isActive: get(isActive, "[0].value"),
            customerId: "",

        },
        onSubmit,
    });

    const onClear = (field) => async () => {
        await formik.setFieldValue(field, "")
        formik.submitForm()
    }

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-start", md: "flex-end" }}>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <Button
                            variant="contained"
                            color="success" // El color verde para el botón
                            startIcon={<SaveAltIcon />} // Icono de exportar
                            onClick={() =>  exportToExcel(clients.data?.data, 'Clientes')}
                        >
                            Exportar
                        </Button>
                    </Grid>
                    {/* <Grid item xs={12} md={4} lg={3} xl={2}> Se quita el boton para crear Nuevo Cliente desde TMS
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button className='w-[100px] min-w-[100px]' component={Link} variant="contained" color="secondary" to="new">{__(`toolbar.btn`)}</Button>
                            <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
                        </Stack>
                    </Grid> */}
                </Grid>
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent